export default {
  NODE_ENV: 'production',
  ENDPOINTS: {
    CAT4MRO: 'https://backend-dev.cat4mro.com/v1/graphql',
    CAT4MRO_APIHTTP: 'https://qamrocatalogupload.azurewebsites.net',
    NEST_BACKEND: 'https://materialmodule-qa.herokuapp.com',
  },
  IDENTITY: {
    AUTHORITY: 'https://qa-identityadminsts.ulinksolution.com',
    REDIRECT_URI: 'https://qaamsa.cat4mro.com/static/callback.html',
    SILENT_REDIRECT_URI: 'https://qaamsa.cat4mro.com/static/silent-renew.html',
    POST_LOGOUT_REDIRECT_URI: 'https://qaamsa.cat4mro.com',
  },
  ApplicationInsightsKey: '8edf663c-5c5c-4e12-aea2-cb3e1d78362c',
};



// WEBPACK FOOTER //
// ./src/config/env.production.js